module.exports = __webpack_public_path__ + "static/img/step2-image.66048e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step2-image.png
// module id = +/fb
// module chunks = 1